import { render } from "./kubeovn.io.iptableseip.vue?vue&type=template&id=39b3253c"
import script from "./kubeovn.io.iptableseip.vue?vue&type=script&lang=js"
export * from "./kubeovn.io.iptableseip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__